export enum Permissions {
  EDIT_USERS = 'edit_users',
  VIEW_MERCHANTS = 'view_merchants',
  VIEW_SETTLEMENT_REPORT = 'view_settlement_report',
  VIEW_QB_USERS = 'view_qb_users',
  VIEW_MERCHANT_ORDERS = 'view_merchant_orders',
  VIEW_CORPORATE_WALLET = 'view_corporate_wallet_qb',
  EDIT_CORPORATE_WALLET = 'edit_corporate_wallet',
  ADD_MERCHANT_BACKOFFICE_USER = 'add_merchant_backoffice_user',
  PROCESS_CARD_REFUNDS = 'process_card_refunds',
  PROCESS_FCU_REFUNDS = 'process_fcu_refunds',
  EDIT_RULES_ENGINE_RULES = 'edit_rules_engine_rules',
  VIEW_FCU_INFO = 'view_fcu_info',
  EDIT_FCU_INFO = 'edit_fcu_info',
  DEVELOPER = 'developer',
}
